import { gql } from '@apollo/client';

export const onboardingQuery = gql`
  query GetOnboarding($sessionContext: SessionContext!, $appId: String!) {
    onboarding(sessionContext: $sessionContext, appId: $appId) {
      onboardingCollection {
        containerItemsPage {
          items {
            ...OnboardingMediaMetadataItem
          }
        }
      }
    }
  }

  fragment OnboardingMediaMetadataItem on MediaMetadata {
    id
    title
    metadataImages {
      poster {
        url
      }
    }
  }
`;
